import { IEmailNotificationChannelSettings } from '@src/types/notifications.types'

/**
 * Turns the settings form into the API payload: `knowledge_space_subscriptions` is read-only, the
 * selection is written back as `subscribed_knowledge_space_ids` and the backend stores the spaces
 * missing from that list as opt-outs.
 */
export default function toEmailSettingsPayload(email: IEmailNotificationChannelSettings): IEmailNotificationChannelSettings {
  const { knowledge_space_subscriptions: subscriptions, ...payload } = email

  if (!subscriptions) {
    return payload
  }

  return {
    ...payload,
    subscribed_knowledge_space_ids: subscriptions.filter((subscription) => subscription.subscribed).map((subscription) => subscription.id)
  }
}
